import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar__item" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Docs")
const _hoisted_3 = { class: "navbar__item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Join Discord")
const _hoisted_5 = {
  key: 0,
  class: "navbar__item"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Linking Site")
const _hoisted_7 = { class: "navbar__item--mobile" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Sign out ")
const _hoisted_9 = { class: "navbar__item--mobile" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Switch Organization ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_external_anchor = _resolveComponent("external-anchor")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_nav_bar = _resolveComponent("nav-bar")!

  return (_openBlock(), _createBlock(_component_nav_bar, { ref: "dashboardNav" }, {
    items: _withCtx(() => [
      _createElementVNode("li", _hoisted_1, [
        _createVNode(_component_external_anchor, {
          class: "anchor--primary",
          href: "https://docs.steamcord.io",
          onClick: _ctx.closeNav
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_external_anchor, {
          class: "anchor--primary",
          href: "https://discord.steamcord.io",
          onClick: _ctx.closeNav
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (_ctx.showLinkingSite && _ctx.currentOrg?.slug)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_external_anchor, {
              class: "anchor--primary",
              href: `https://${_ctx.currentOrg.slug}.steamcord.link`,
              onClick: _ctx.closeNav
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["href", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    "items-last": _withCtx(() => [
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "anchor--primary",
          to: "/signout"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, {
          class: "navbar__item--mobile button--primary",
          to: "/dashboard",
          onClick: _ctx.closeNav
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_fa_icon, { icon: ['far', 'exchange'] })
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 512))
}